import { removeRecentCity as removeRecentCityAction } from 'app/store/reducers/location';
import { getFlixTldFromHostname } from 'app/functions';
import { recentCitiesCookieSelector, recentCitiesSelector } from 'app/store/selectors';
import cookie from 'js-cookie';
import { ThunkType } from 'app/hooks/appHooks';
import { SearchMaskDirection } from 'app/models/types/store/location';

export type RemoveRecentCityType = {
  direction: SearchMaskDirection;
  cityId: string;
};

export const removeRecentCity =
  ({ direction, cityId }: RemoveRecentCityType): ThunkType<void> =>
  (dispatch, getState) => {
    dispatch(removeRecentCityAction({ direction, cityId }));

    const state = getState();
    const domain = getFlixTldFromHostname(document.location.hostname) || document.location.hostname;
    const cookies: { from: string; to: string } = recentCitiesCookieSelector(state);
    const recentCities: ReturnType<typeof recentCitiesSelector> = recentCitiesSelector(state);
    cookie.set(cookies[direction], JSON.stringify(recentCities[direction]), { domain });
  };
